<template>
  <q-btn flat round dense size="sm"
         :icon="appInboxStore.hasUnread ? 'notifications_active' : 'notifications_none'"
         @click="onClick">
    <q-badge v-if="appInboxStore.hasUnread" color="red" floating rounded>{{ unreadLabel }}</q-badge>
    <q-tooltip v-if="!isMobile">Notifications</q-tooltip>

    <!-- Ordinateur : menu au-dessus de la cloche -->
    <q-menu v-if="!isMobile" class="app-notif-menu" anchor="top left" self="bottom left" :offset="[0, 8]"
            max-height="80vh">
      <app-notification-panel style="min-width: 320px; max-width: 380px" />
    </q-menu>
  </q-btn>

  <!-- Mobile : feuille en bas d'écran, pleine largeur (un menu accroché à la cloche débordait à droite) -->
  <q-dialog v-if="isMobile" v-model="sheetOpen" position="bottom" full-width>
    <div class="app-notif-sheet">
      <app-notification-panel />
    </div>
  </q-dialog>
</template>

<script>
import {mapStores} from "pinia";
import {useAppInboxStore} from "src/stores/appInboxStore";
import AppNotificationPanel from "./appNotificationPanel.vue";

export default {
  name: 'AppNotificationBell',
  components: {AppNotificationPanel},

  data() {
    return {
      sheetOpen: false,
    }
  },

  computed: {
    ...mapStores(useAppInboxStore),
    unreadLabel() {
      return this.appInboxStore.unread > 99 ? '99+' : this.appInboxStore.unread
    },
    isMobile() {
      return this.$q.screen.lt.sm
    },
  },

  methods: {
    onClick() {
      if (this.isMobile) this.sheetOpen = true
    },
  },
}
</script>

<!-- Menu et feuille téléportés hors du composant : classes globales -->
<style lang="scss">
.q-menu.app-notif-menu {
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.18);
}
.app-notif-sheet {
  width: 100%;
  max-height: 85vh;
  overflow-y: auto;
  border-radius: 14px 14px 0 0;
  background: var(--q-dark-page, white);
  box-shadow: 0 -6px 24px rgba(0, 0, 0, 0.2);
}
.body--light .app-notif-sheet {
  background: white;
}
.body--dark .app-notif-sheet {
  background: var(--q-dark);
}
</style>
